/**
 * Copyright (c) 2018-present clchart Contributors.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// 数据看板

// 画买卖盘和Tick

import {
    _fillRect,
    _drawRect,
    _drawHline,
    _setLineWidth,
    _drawTxt,
    _getTxtWidth,
    _drawBegin,
    _drawEnd,
    _clearRect,
    _drawLineAlone,
} from './cl.draw'
import {
    formatVolume,
    formatMoney,
    formatPrice,
    updateJsonOfDeep,
    copyJsonOfDeep,
    offsetRect,
    formatFloat,
    fromTTimeToStr,
    formatInteger,
} from '../cl.utils'
import {
    initCommonInfo,
    checkLayout
} from './cl.chart.init'
import {
    CHART_LAYOUT,
    ASCIIMAPS
} from '../cl.chart.res'

import { getValue } from '../datas/cl.data'

/**
 * Class representing ClChartBoard
 * @export
 * @class ClChartBoard
 */
export default class ClChartBoard {
    /**

     * Creates an instance of ClChartBoard.
     * @param {Object} father order chart's parent context
     */
    constructor(father) {
        initCommonInfo(this, father)
        this.dataLayer = father.dataLayer
        this.linkInfo = this.dataLayer.linkInfo
        // console.log(this.dataLayer.keyInfo, this.linkInfo.curKey);
        
        this.static = this.linkInfo.static
        this.data = {}
        this.father = father
    }
    /**
     * init order chart
     * @param {Object} cfg
     * @memberof ClChartBoard
     */
    init(cfg, callback) {
        this.callback = callback
        this.rectMain = cfg.rectMain || {
            left: 0,
            top: 0,
            width: 200,
            height: 300
        }
        
        this.layout = updateJsonOfDeep(cfg.layout, CHART_LAYOUT)

        this.config = copyJsonOfDeep(cfg.config)
        // console.log(JSON.stringify(this.config));
        // updateJsonOfDeep(cfg.config, CHART_BOARD)

        // 下面对配置做一定的校验
        this.checkConfig()
        // 再做一些初始化运算，下面的运算范围是初始化设置后基本不变的数据
        this.setPublicRect()
        // 
        this.style = this.config.style || 'normal'
        if (this.style  === 'fwindow') {
            this.context = this.father.swimCanvas.context
        }

        // console.log(this.rectMain, this.rectChart);
    }
    onClear() {
        // console.log(this.style);
        // if (this.style  === 'fwindow') {
            _clearRect(this.context, this.rectMain.left - this.scale, this.rectMain.top - this.scale, this.rectMain.width + 2 * this.scale, this.rectMain.height + 2 * this.scale)
        // }
        // _drawBegin(this.context, this.color.back)
        // _drawEnd(this.context)
    }
    changeCfg(newcfg) {
        if (newcfg.config !== undefined) {
            this.config = copyJsonOfDeep(newcfg.config)
            if (this.config.style === 'fwindow') {
                this.context = this.father.swimCanvas.context
            }
        }
        if (newcfg.rectMain !== undefined) {
            this.rectMain = newcfg.rectMain
            this.setPublicRect()
        }
        // console.log(this.rectMain, this.rectChart);
        // 重画
        this.onPaint()
    }
    /**
     * check config
     * @memberof ClChartBoard
     */
    setRowsInfo(chunk, father) {
        if (father !== undefined) {
            if (chunk.font === undefined) {
                chunk.font = father.font
            }
            if (chunk.spaceX === undefined) {
                chunk.spaceX = father.spaceX
            } else {
                chunk.spaceX *= this.scale;
            }
            if (chunk.spaceY === undefined) {
                chunk.spaceY = father.spaceY
            } else {
                chunk.spaceY *= this.scale;
            }
            if (chunk.pixel === undefined) {
                chunk.pixel = father.pixel
            } else {
                chunk.pixel *= this.scale;
            }
        }
        // spaceX
        for (let ridx = 0; ridx < chunk.rows.length; ridx++) {
            const cols = chunk.rows[ridx].cols;
            // let maxW = 0
            for (let cidx = 0; cidx < cols.length; cidx++) {
                if (cols[cidx].pixel === undefined) {
                    cols[cidx].pixel = chunk.pixel
                } else {
                    cols[cidx].pixel *= this.scale;
                }
                cols[cidx].chLen = _getTxtWidth(this.context, '8', chunk.font, cols[cidx].pixel)
            }
        }
    }
    checkConfig() { // 检查配置有冲突的修正过来
        checkLayout(this.layout)
        this.config.title.spaceX *= this.scale;
        this.config.title.spaceY *= this.scale;
        this.config.title.pixel *= this.scale;
        this.config.boards.spaceX *= this.scale;
        this.config.boards.spaceY *= this.scale;
        this.config.boards.pixel *= this.scale;
        this.config.boards.chLen = _getTxtWidth(this.context, '8', this.config.boards.font, this.config.boards.pixel)

        this.config.header.spaceX *= this.scale;
        this.config.header.spaceY *= this.scale;
        this.config.header.pixel *= this.scale;

        if (this.config.header.display !== 'none') {
            this.setRowsInfo(this.config.header)
        }
        if (this.config.boards.upper.display !== 'none') {
            this.setRowsInfo(this.config.boards.upper, this.config.boards)
        }
        if (this.config.boards.footnote.display !== 'none') {
            this.setRowsInfo(this.config.boards.footnote, this.config.boards)
        }
        if (this.config.boards.middle.display !== 'none') {
            this.setRowsInfo(this.config.boards.middle, this.config.boards)
        }
        // // 这里计算不同字体的宽度
        // this.textLen = _getTxtWidth(this.context, '涨', this.layout.digit.font, this.layout.digit.pixel)
        // this.minuLen = _getTxtWidth(this.context, '15:30', this.layout.digit.font, this.layout.digit.pixel)
        // this.charLen = _getTxtWidth(this.context, '8', this.layout.digit.font, this.layout.digit.pixel)
    }
    /**
     * Calculate all rectangular areas
     * @memberof ClChartBoard
     */
    calcRowHeight(chunk) {
        let curH = 0
        for (let ridx = 0; ridx < chunk.rows.length; ridx++) {
            let rowH = chunk.pixel + 2 * chunk.spaceY
            const cols = chunk.rows[ridx].cols;
            for (let cidx = 0; cidx < cols.length; cidx++) {
                if (cols[cidx].pixel !== undefined) {
                    const cH = cols[cidx].pixel + 2 * chunk.spaceY
                    if (cH > rowH) {
                        rowH = cH
                    }
                }
            }
            chunk.rows[ridx]['height'] = rowH
            curH += rowH
        }
        return curH
    }
    setPublicRect() {
        this.rectChart = offsetRect(this.rectMain, this.layout.margin)
        // 这里需要计算好每个区域的 Y 尺寸 
        let chunks = 0
        let titleH = 0
        let headeH = 0
        let footnH = 0
        let middlH = 0
        let upperH = 0

        if (this.config.title.display !== 'none') {
            titleH = this.config.title.pixel + 2 * this.config.title.spaceY
            // chunks++
        }
        if (this.config.header.display !== 'none') {
            headeH = this.calcRowHeight(this.config.header)
            chunks++
        }
        if (this.config.boards.upper.display !== 'none') {
            upperH = this.calcRowHeight(this.config.boards.upper)
            chunks++
        }
        if (this.config.boards.footnote.display !== 'none') {
            footnH = this.calcRowHeight(this.config.boards.footnote)
            chunks++
        }
        if (this.config.boards.middle.display !== 'none') {
            middlH = this.calcRowHeight(this.config.boards.middle)
            // chunks++
        }

        this.rectTitle = {
            left: 0,
            top: 0,
            width: 0,
            height: 0
        }
        this.rectBoard = {
            left: 0,
            top: 0,
            width: 0,
            height: 0
        }
        this.rectHeader = {
            left: 0,
            top: 0,
            width: 0,
            height: 0
        }
        this.rectUpper = {
            left: 0,
            top: 0,
            width: 0,
            height: 0
        }
        this.rectMiddle = {
            left: 0,
            top: 0,
            width: 0,
            height: 0
        }
        this.rectFootnote = {
            left: 0,
            top: 0,
            width: 0,
            height: 0
        }

        let chartH = titleH + headeH + middlH + footnH + upperH
        let spaceY = 0
        if (this.config.boards.cols.length < 1) {
            // 这里计算块之间的间隔
            if (chunks > 0) {
                spaceY = (this.rectChart.height - chartH) / chunks
            }
            spaceY = spaceY < 0 ? 0 : spaceY
        }
        let upperY = this.rectChart.top
        if (this.config.title.display !== 'none') {
            this.rectTitle = {
                left: this.rectChart.left,
                top: upperY,
                width: this.rectChart.width,
                height: titleH // + spaceY
            }
            upperY += titleH // + spaceY
        }
        if (this.config.header.display !== 'none') {
            this.rectHeader = {
                left: this.rectChart.left,
                top: upperY,
                width: this.rectChart.width,
                height: headeH + spaceY
            }
            upperY += headeH + spaceY
        }
        if (this.config.boards.upper.display !== 'none') {
            this.rectUpper = {
                left: this.rectChart.left,
                top: upperY,
                width: this.rectChart.width,
                height: upperH + spaceY
            }
            upperY += upperH + spaceY
        }
        if (this.config.boards.middle.display !== 'none') {
            this.rectMiddle = {
                left: this.rectChart.left,
                top: upperY,
                width: this.rectChart.width,
                height: middlH // + spaceY
            }
            upperY += middlH // + spaceY

            if (this.config.boards.footnote.display !== 'none') {
                this.rectFootnote = {
                    left: this.rectChart.left,
                    top: upperY,
                    width: this.rectChart.width,
                    height: footnH + spaceY
                }
            }
        } else {
            if (this.config.boards.cols.length > 0) {
                this.rectBoard = {
                    left: this.rectChart.left,
                    top: upperY,
                    width: this.rectChart.width,
                    height: this.rectChart.height - chartH - chunks * spaceY
                }
            }
            // let footnY = this.rectChart.top + this.rectChart.height
            // if (this.config.boards.footnote.display !== 'none') {
            //     this.rectFootnote = {
            //         left: this.rectChart.left,
            //         top: footnY - footnH - spaceY,
            //         width: this.rectChart.width,
            //         height: footnH + spaceY
            //     }
            // }
        }

    }
    drawClear() {
        _fillRect(this.context, this.rectChart.left, this.rectChart.top, this.rectChart.width, this.rectChart.height, this.color.back)

        _drawBegin(this.context, this.color.grid)
        _drawRect(this.context, this.rectChart.left, this.rectChart.top, this.rectChart.width, this.rectChart.height)
        if (this.config.title.display !== 'none') {
            _drawHline(this.context, this.rectChart.left, this.rectChart.left + this.rectChart.width, this.rectTitle.top + this.rectTitle.height)
        }
        if (this.config.header.display !== 'none') {
            _drawHline(this.context, this.rectChart.left, this.rectChart.left + this.rectChart.width, this.rectHeader.top + this.rectHeader.height)
        }
        if (this.config.boards.upper.display !== 'none') {
            _drawHline(this.context, this.rectChart.left, this.rectChart.left + this.rectChart.width, this.rectUpper.top + this.rectUpper.height)
        }
        if (this.config.boards.footnote.display !== 'none') {
            _drawHline(this.context, this.rectChart.left, this.rectChart.left + this.rectChart.width, this.rectFootnote.top + this.rectFootnote.height)
        }
        if (this.config.boards.middle.display !== 'none' && (this.config.boards.cols.length < 1)) {
            _drawHline(this.context, this.rectChart.left, this.rectChart.left + this.rectChart.width, this.rectMiddle.top)
            _drawHline(this.context, this.rectChart.left, this.rectChart.left + this.rectChart.width, this.rectMiddle.top + this.rectMiddle.height)
        }
        _drawEnd(this.context)
    }
    onPaint() {
        this.data = this.father.getData(this.hotKey)

        // console.log(this.config);
        // console.log(this.rectChart, this.rectTitle, this.rectHeader, this.rectUpper, this.rectMiddle, this.rectBoard, this.rectFootnote);

        _setLineWidth(this.context, this.scale)
        this.drawClear() // 清理画图区

        // _drawLineAlone(this.context, this.rectChart.left, this.rectChart.top, this.rectChart.left + this.rectChart.width, this.rectChart.top + this.rectChart.height, this.color.cursor)
        // _drawLineAlone(this.context, this.rectChart.left + this.rectChart.width, this.rectChart.top, this.rectChart.left, this.rectChart.top + this.rectChart.height, this.color.cursor)
        this.drawTitle()
        this.drawNormal(this.rectHeader, this.config.header)
        this.drawNormal(this.rectUpper, this.config.boards.upper)
        this.drawNormal(this.rectFootnote, this.config.boards.footnote)
        this.drawNormal(this.rectMiddle, this.config.boards.middle)
        this.drawBoard()
        
    }
    drawTitle() {
        if (this.config.title.display !== 'none') {
            _fillRect(this.context, this.rectTitle.left + this.scale, this.rectTitle.top + this.scale,
            this.rectTitle.width - 1 * this.scale,
            this.rectTitle.height - 1 * this.scale, this.color.baktxt)

            let moveX = this.rectTitle.left + this.config.title.spaceX;
            let moveY = this.rectTitle.top + this.config.title.spaceY;
            _drawTxt(this.context, moveX, moveY, this.config.title.label,
                this.config.title.font, this.config.title.pixel, this.color[this.config.title.clr]);
        }

    }
    drawNormal(rect, chunk) {
        if (chunk.display === 'none') {
            return 
        }
        let sumH = 0
        for (let ridx = 0; ridx < chunk.rows.length; ridx++) {
            sumH += chunk.rows[ridx]['height']
        }
        let spaceY = 0
        if (sumH < rect.height) {
            spaceY = (rect.height - sumH) / (chunk.rows.length + 1)
        }
        // console.log(sumH, rect.height, spaceY);
        let pixel = chunk.pixel;
        let moveY = rect.top + spaceY;
        for (let ridx = 0; ridx < chunk.rows.length; ridx++) {
            let moveX = rect.left
            const cols = chunk.rows[ridx].cols;
            for (let cidx = 0; cidx < cols.length; cidx++) {
                moveX += chunk.spaceX
                if (cols[cidx].pixel !== undefined) {
                    pixel = cols[cidx].pixel
                }
                const drawW = cols[cidx].maxchs ? cols[cidx].maxchs * cols[cidx].chLen : rect.width
                if (chunk.display === 'text') {
                    const showY = (chunk.rows[ridx]['height'] - pixel - chunk.spaceY)
                    const txt = this.getVar(cols[cidx])
                    const clr = this.getClr(cols[cidx], txt)
                    // console.log(txt, chunk.rows[ridx]['height'], pixel, chunk.spaceY, spaceY);
                    // console.log(txt, cols[cidx], this.data)
    
                    let showX = 0;
                    const showW = _getTxtWidth(this.context, txt, chunk.font, pixel)
                    // 这里可以检查长度是否超过 width 如果超出需要缩小字体大小
                    if (cols[cidx].align !== 'left') {
                        if (cols[cidx].align === 'center') {
                            showX += (drawW - showW) / 2;
                        }
                        else {
                            showX += drawW - showW;
                        }
                    }
                    // console.log(txt, clr, moveX + showX, moveY + spaceY, this.static)
                    _drawTxt(this.context, moveX + showX, moveY + showY, txt, chunk.font, pixel, clr);
                }
                if (chunk.display === 'rate') {
                    const val = this.getVar(cols[cidx])
                    const rW = drawW * val
                    const gW = drawW - rW
                    if (rW > this.scale) {
                        _fillRect(this.context, moveX, moveY, rW, pixel, this.color.red)
                    }
                    if (gW > this.scale) {
                        _fillRect(this.context, moveX + rW, moveY, gW, pixel, this.color.green)
                    }
                }
                moveX += drawW + chunk.spaceX 
            }
            moveY += chunk.rows[ridx]['height'] + spaceY
        }
    }
    drawBoard() {
        if (this.rectBoard.width < this.scale) {
            return
        }
        const chunk = this.config.boards
        const rect = this.rectBoard
        const oneH = (chunk.pixel + this.scale + chunk.spaceY)
        let maxRecs = Math.floor((rect.height - chunk.spaceY) / oneH)
        let spaceY = (rect.height - maxRecs * oneH) / (maxRecs + 1)
        
        let start = this.data.value.length - maxRecs
        start = start < 0 ? 0 : start
        
        // console.log(start, maxRecs, spaceY, chunk.spaceY);

        let pixel = chunk.pixel;
        let moveY = rect.top + spaceY;
        for (let index = start; index < this.data.value.length; index++) {
            let moveX = rect.left
            const cols = chunk.cols;
            for (let cidx = 0; cidx < cols.length; cidx++) {
                moveX += chunk.spaceX
                const showY = (oneH - pixel - chunk.spaceY)
                const txt = this.getVar(cols[cidx], index)
                const clr = this.getClr(cols[cidx], txt, index)
                
                // console.log(start, txt, cols[cidx], this.data, index)

                let showX = 0;
                const drawW = cols[cidx].maxchs * chunk.chLen
                const showW = _getTxtWidth(this.context, txt, chunk.font, pixel)
                // 这里可以检查长度是否超过 width 如果超出需要缩小字体大小
                if (cols[cidx].align !== 'left') {
                    if (cols[cidx].align === 'center') {
                        showX += (drawW - showW) / 2;
                    }
                    else {
                        showX += drawW - showW;
                    }
                }
                // console.log(txt, clr, moveX + showX, moveY + spaceY, drawW, showW, cols[cidx].maxchs, chunk.chLen)
                _drawTxt(this.context, moveX + showX, moveY + showY, txt, chunk.font, pixel, clr);
                moveX += drawW + chunk.spaceX 
            }
            moveY += oneH + spaceY
            
        }
        
    }
    getClr(colume, val, index) {
        if (colume.clr !== undefined) {
            return this.color[colume.clr]
        }
        if (index === undefined) {
            index = -1
        }
        if (colume.fieldclr !== undefined) {
            const clr = getValue(this.data, colume.fieldclr, index);
            return this.color[clr]
        }
        val = parseFloat(val)
        let clr = this.color.txt
        switch (colume.getclr) {
            case "getCodeClr":
                clr = this.color.code;
                break;
            case "getNameClr":
                clr = this.color.name;
                break;
            case "getIntClr":
                clr = this.color.yellow;
                break;
            case "getSubClr":
                const agop = parseFloat(getValue(this.data, colume.subfield, index))
                // console.log(colume.subfield, agop);
                if (agop) {
                    clr = val > agop ? this.color.red : (val < agop ? this.color.green : this.color.yellow)
                }
                else {
                    clr = this.color.yellow
                }
                break;
            case "getPrcClr":
                // 需要和前收盘做比较
                // console.log(this.keyInfo, this.keyInfo[curKey], curKey);
                if (this.static !== undefined) {
                    const agop = this.static.agoprc
                    clr = val > agop ? this.color.red : (val < agop ? this.color.green : this.color.yellow)
                }
                else {
                    clr = this.color.yellow
                }
                break;
            case "getFltClr":
                clr = this.color.yellow;
                break;
            case "getZeroClr":
                clr = val > 0.0000001 ? this.color.red : (val < -0.0000001 ? this.color.green : this.color.white)
                break;
            case "getHalfClr":
                // let val = getValue(this.data, colume.field, index);
                clr = val > 0.5 ? this.color.red : this.color.green
                break;
            case "getVolClr":
            case "getMnyClr":
                clr = this.color.vol;
                break;
            
            default:
                clr = this.color.yellow;
        }
        return clr
    }
    getVar(colume, index) {
        if (colume.label !== undefined) {
            return colume.label
        }
        if (index === undefined) {
            index = -1
        }
        let showtxt = '--'
        let val = getValue(this.data, colume.field, index); 
        
        switch (colume.getvar) {
            case "getMapVar":
                if (ASCIIMAPS[colume.field] !== undefined) {
                    showtxt = ASCIIMAPS[colume.field]
                }
                break;
            case "getInfoVar":
                if (this.static !== undefined) {
                    showtxt = this.static[colume.field]
                }
                break;
            case "getMnyVar":
                showtxt = formatMoney(val, 100);
                break;
            case "getVolVar":
                showtxt = formatVolume(val, 1);
                break;
            case "getHandVar":
                showtxt = formatVolume(val, 0.01);
                break;
            case "getMinuVar":
                // console.log(val, colume.field, index);
                showtxt = fromTTimeToStr(val/1000, 'minute');
                // if (index > 0) {
                //     let agov = getValue(this.data, colume.field, index - 1); 
                //     showtxt = fromTTimeToStr(val/1000, 'minute', agov/1000);
                // }
                // else {
                //     showtxt = fromTTimeToStr(val/1000, 'minute');
                // }
                break;
            case "getIntVar":
                showtxt = formatInteger(val, 1);
                break;
            case "getPrcVar":
                showtxt = formatPrice(val, 2);
                break;
            case "getFltVar":
                showtxt = formatFloat(val, 2, colume.maxchs);
                break;
            case "getPctVar":
                showtxt = formatPrice(val * 100, 2) + '%';
                
                break;
            case "getStrVar":
            default:
                showtxt = val.toString();
                break;
        }
        return showtxt
    }
}